"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const brandedheart02 = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 56 50",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-brandedheart02` : '') + (description ? ` desc-brandedheart02` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-brandedheart02"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-brandedheart02"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M30.22 4.48 28 6.73l-2.23-2.25A15 15 0 0 0 1.58 8.43l-.28.6a15.34 15.34 0 0 0 2.64 16.46l22.63 23.9c.77.81 2.08.81 2.86 0l22.2-23.45a15.31 15.31 0 0 0 2.78-17.5l-.31-.61a15 15 0 0 0-23.88-3.35Z",
    fill: "#F8985A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m28 6.73 2.22-2.25A15 15 0 0 1 54.1 7.83l.31.6a15.31 15.31 0 0 1-2.78 17.5L29.43 49.4c-.39.4-.9.6-1.43.61V6.73Z",
    fill: "#F26B1C"
  }));
};
var _default = exports.default = brandedheart02;